import src from "IMAGE";
export default { src, width: 265, height: 127, blurWidth: 0, blurHeight: 0};
